import { useTheme, Typography, Box } from '@mui/material';
import { memo } from 'react';
import { ContentSection } from '@/types/generated';
import { getEyebrowStyles, getHeadingStyles, headingWrapperStyles } from './Heading.styles';
import { HeadingTag } from '@shared-components/types';
import resolveContentfulHeadingTag from '@utils/resolveContentfulHeadingTag';
import getHeadingVariant from '@utils/resolveContentfulHeadingVariant';
type HeadingProps = Pick<ContentSection, 'eyebrow' | 'eyebrowHtag' | 'title' | 'titleHtag'>;
export default memo(function Heading({
  eyebrowHtag = 'h4',
  eyebrow,
  title,
  titleHtag = 'h1'
}: HeadingProps) {
  const theme = useTheme();
  return <Box data-testid="product_feature_heading_box" sx={headingWrapperStyles}>
			{eyebrow && <Typography data-testid="product_feature_eyebrow_text" variant={getHeadingVariant(eyebrowHtag as HeadingTag)} sx={getEyebrowStyles(theme)} component={resolveContentfulHeadingTag(eyebrowHtag as HeadingTag)}>
					{eyebrow}
				</Typography>}
			{title && <Typography data-testid="product_feature_heading_text" variant={getHeadingVariant(titleHtag as HeadingTag)} sx={getHeadingStyles(theme)} component={resolveContentfulHeadingTag(titleHtag as HeadingTag)}>
					{title}
				</Typography>}
		</Box>;
});